import React, { useState, useEffect, useRef } from "react";
// componentes
import { Modal, ModalBody, ModalHeader, Col, Row, Button } from "reactstrap";
import Select from "react-select";
import TextEditor from "../../../components/TextEditor";
import ColorPicker from "../../../components/ColorPicker/ColorPicker";
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";
// redux
import { connect } from "react-redux";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";
// services
import { updateSpeaker } from "../../../utils/services/speaker";
import { getSchedule } from "../../../utils/services/schedule";
import { getUrlFiles } from "../../../utils/services/files";

function ModalEditSpeaker(props) {
  const { isOpen, toggle } = props;

  //state de loading
  const [isLoading, setIsLoading] = useState(false);
  //state de modais e alertas
  const [modalBackdrop, setModalBackdrop] = useState(false);
  const [successDlg, setSuccessDlg] = useState(false);
  const [submitErrorMessage, setSubmitErrorMessage] = useState("");
  //state de erros
  const [erroForm, setErroForm] = useState({});
  //state de dados do formulário
  const [id] = useState(props?.data?.id);
  const [name, setName] = useState(props?.data?.name);
  const [position, setPosition] = useState(props?.data?.position);
  const [category, setCategory] = useState(props?.data?.category);
  const [photoPreview, setPhotoPreview] = useState(props?.data?.photo);
  const [photo, setPhoto] = useState(null);
  const [about, setAbout] = useState(props?.data?.about);
  const [facebook, setFacebook] = useState(props?.data?.facebook);
  const [instagram, setInstagram] = useState(props?.data?.instagram);
  const [linkedin, setLinkedin] = useState(props?.data?.linkedin);
  const [whatsapp, setWhatsapp] = useState(props?.data?.whatsapp);
  const [site, setSite] = useState(props?.data?.site);
  const [color, setColor] = useState(props?.data?.color);
  const [order, setOrder] = useState(props?.data?.order);
  //state de agendas
  const [agendas, setAgendas] = useState([]);
  const [agendasMulti, setAgendasMulti] = useState([]);
  const [allAgendas, setAllAgendas] = useState(false);

  const refAboutContent = useRef(null);

  // alterna o backdrop do modal
  function toggleBackdrop() {
    setModalBackdrop(!modalBackdrop);
  }

  // atualiza a pré-visualização da foto ao selecionar um novo arquivo
  const onImageChange = (event, setStateFunction) => {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (e) => {
        setStateFunction(e.target.result);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  // envia a nova foto do palestrante, se houver, e retorna a url
  async function getImage() {
    if (!photo || !photo.type.startsWith("image/")) {
      return null;
    }

    const data = new FormData();
    data.append("files", photo);
    data.append("folder", "palestrantes");
    data.append("eventId", props.idEvent);

    const response = await getUrlFiles(
      data,
      props.state.global_user_data.data.token,
    );

    return response?.[0]?.url ?? null;
  }

  // valida os campos obrigatórios antes de enviar o formulário
  function verifyErros() {
    if (!name) {
      setErroForm({ name: "O campo Nome é obrigatório" });
      return;
    } else setErroForm({});

    submitForm();
  }

  // monta o payload e atualiza o palestrante
  async function submitForm() {
    setIsLoading(true);
    try {
      let image = await getImage();
      if (!image && photoPreview) {
        image = photoPreview;
      }

      const agendaArray = [];
      if (allAgendas) {
        agendas.forEach((e) => agendaArray.push(e.id));
      } else {
        agendasMulti.forEach((e) => agendaArray.push(e.value));
      }

      const data = {
        eventId: props.idEvent,
        name,
        position,
        category,
        photo: image,
        about: refAboutContent.current.getContent(),
        facebook,
        instagram,
        linkedin,
        whatsapp,
        site,
        color,
        order,
        agendas: agendaArray,
      };

      const res = await updateSpeaker(data, props.data.id);
      if (res.message === "updated") {
        setSuccessDlg(true);
      } else {
        setSubmitErrorMessage("Erro ao editar palestrante.");
      }
    } catch (error) {
      console.error("Erro ao editar palestrante:", error);
      setSubmitErrorMessage("Erro ao editar palestrante.");
    } finally {
      setIsLoading(false);
    }
  }

  // monta as opções já selecionadas do select de agendas
  function funcAgendas() {
    var agendasArray = [];
    if (props.data.agendas?.length > 0) {
      props.data.agendas.forEach((a) => {
        agendasArray.push({ label: a.title, value: a.id });
      });

      if (agendas?.length === agendasArray?.length) {
        agendasArray = [];
        agendasArray.push({ label: "TODOS", value: "todos" });

        setAllAgendas(true);
      }
    }
    setAgendasMulti(agendasArray);
  }

  // busca as agendas do evento para popular o select
  async function getAgendas() {
    const res = await getSchedule({
      jwt: props.state.global_user_data.data.token,
      id: props.idEvent,
      offset: 1,
      limit: 9999,
      search: "",
    });

    if (res?.agenda?.data) {
      setAgendas(res.agenda.data);
    } else {
      toast.error("Erro ao buscar agendas.");
    }
  }

  useEffect(() => {
    getAgendas();
  }, []);

  useEffect(() => {
    funcAgendas();
  }, [agendas]);

  // trata a seleção de "todos" no select de agendas
  function handleAgendaMulti(a) {
    const selected = a.filter((e) => e.value === "todos");
    if (selected.length > 0) {
      a = selected;
      setAllAgendas(true);
    } else {
      setAllAgendas(false);
    }
    setAgendasMulti(a);
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        toggle={() => {
          toggleBackdrop();
        }}
        autoFocus={true}
        centered={true}
      >
        {successDlg ? (
          <SweetAlert
            success
            title={"Editado"}
            onConfirm={() => {
              setSuccessDlg(false);
              toggle();
            }}
          >
            {"Palestrante editado com sucesso!"}
          </SweetAlert>
        ) : null}
        {submitErrorMessage && (
          <SweetAlert
            danger
            title="Erro"
            onConfirm={() => setSubmitErrorMessage("")}
          >
            {submitErrorMessage}
          </SweetAlert>
        )}
        <ModalHeader toggle={toggle}>Editar Palestrante</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <div>
                <label className="form-label">ID</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={id}
                  disabled={true}
                />
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: 10 }}>
            <Col md={12}>
              <div>
                <label className="form-label">Nome*</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={name}
                  onChange={(e) => setName(e.target.value)}
                />
                {erroForm.name && (
                  <span className="text-danger">{erroForm.name}</span>
                )}
              </div>
            </Col>
          </Row>
          <Row>
            <Col
              sm={6}
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <label
                htmlFor="formFile"
                className="form-label"
                style={{ marginBottom: 0 }}
              >
                Foto
              </label>
              <label htmlFor="inputImage" style={{ marginBottom: 0 }}>
                <i className="bx bx-pencil" style={{ cursor: "pointer" }} />
              </label>

              <input
                id="inputImage"
                type={"file"}
                onChange={(e) => {
                  onImageChange(e, setPhotoPreview);
                  setPhoto(e.target.files?.[0]);
                }}
                style={{ display: "none" }}
              />
            </Col>

            <Col
              sm={6}
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              {photoPreview && (
                <>
                  <img alt="edit" src={photoPreview} style={{ width: 70 }} />
                  <i
                    className="mdi mdi-trash-can icon-trash"
                    style={{ marginLeft: 70 }}
                    onClick={() => {
                      setPhotoPreview(null);
                    }}
                  />
                </>
              )}
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col md={12}>
              <label className="form-label">Sobre</label>
              <TextEditor refState={refAboutContent} defaultState={about} />
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <div>
                <label className="form-label" style={{ marginTop: "10px" }}>
                  Empresa / Cargo / Especialidade
                </label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={position}
                  onChange={(e) => setPosition(e.target.value)}
                />
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <div>
                <label className="form-label" style={{ marginTop: "10px" }}>
                  Facebook
                </label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={facebook}
                  onChange={(e) => setFacebook(e.target.value)}
                />
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <div>
                <label className="form-label" style={{ marginTop: "10px" }}>
                  Instagram
                </label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={instagram}
                  onChange={(e) => setInstagram(e.target.value)}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div>
                <label className="form-label" style={{ marginTop: "10px" }}>
                  LinkedIn
                </label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={linkedin}
                  onChange={(e) => setLinkedin(e.target.value)}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div>
                <label className="form-label" style={{ marginTop: "10px" }}>
                  WhatsApp
                </label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={whatsapp}
                  onChange={(e) => setWhatsapp(e.target.value)}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div>
                <label className="form-label" style={{ marginTop: "10px" }}>
                  Site
                </label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={site}
                  onChange={(e) => setSite(e.target.value)}
                />
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <div>
                <label className="form-label" style={{ marginTop: "10px" }}>
                  Categoria
                </label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={category}
                  onChange={(e) => setCategory(e.target.value)}
                />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col lg={12}>
              <ColorPicker
                classOfContainer="bg-edit-shedule-event-pickr"
                labelText="Cor"
                setStateFunc={setColor}
                defaultColor={color}
              />
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <div>
                <label className="form-label" style={{ marginTop: "10px" }}>
                  Ordem
                </label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={order}
                  onChange={(e) => setOrder(e.target.value)}
                />
              </div>
            </Col>
          </Row>

          <Row style={{ marginBottom: 20, marginTop: "10px" }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Agendas</label>
                <Select
                  value={agendasMulti}
                  placeholder={"Selecione"}
                  isMulti={true}
                  onChange={(e) => {
                    handleAgendaMulti(e);
                  }}
                  noOptionsMessage={() => "Nenhuma opção encontrada"}
                  options={[
                    {
                      options:
                        agendas?.length > 0 && !allAgendas
                          ? [
                              { label: "TODOS", value: "todos" },
                              ...agendas.map((e) => {
                                return { label: e.title, value: e.id };
                              }),
                            ]
                          : [],
                    },
                  ]}
                  classNamePrefix="select2-selection"
                />
              </div>
            </Col>
          </Row>

          <Row
            style={{
              width: "100%",
              margin: "auto",
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "1rem",
            }}
          >
            <Button
              color="danger"
              style={{ width: 80, marginRight: 10 }}
              onClick={() => toggle()}
            >
              Fechar
            </Button>

            <ButtonSpinner
              isLoading={isLoading}
              title={"Salvar"}
              onClick={verifyErros}
            />
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(ModalEditSpeaker);
